import { createFileRoute } from '@tanstack/react-router';
import { ChatView } from '@/modules/agentes/components/ChatView';

export const Route = createFileRoute('/_authed/agentes_/$agente_/$canal')({
  component: ChatPage,
});

function ChatPage() {
  const { agente, canal } = Route.useParams();
  return <ChatView agente={agente} canal={canal} />;
}
